import React, {Component, Fragment} from 'react';
import AdminReadyButton from '../AdminReadyButton';
import strings from '../../strings';
import {LANGUAGE} from '../../constants';

const excludeForLang = ['de', 'se'];
class TestIntro extends Component {
	constructor(props) {
		super(props);

		this.state = {
			candidateInfo: {
				gender: excludeForLang.includes(strings.getLanguage())
					? ''
					: 'm',
				class: this.props.ageGroup ? this.props.ageGroup : 0,
			},
			ageGroup: this.props.ageGroup ? this.props.ageGroup : null,
			languageSelected:
				this.getAvailableLanguages().length === 1
					? this.getAvailableLanguages()[0]
					: null,
			education: null,
			copied: false,
		};
	}

	getAvailableLanguages = () => {
		let lang = null;
		switch (LANGUAGE) {
			case 'se':
				lang = ['se'];
				break;
			case 'de':
				lang = ['de'];
				break;
			case 'no':
			case 'nn':
			default:
				lang = ['no', 'nn'];
				break;
		}
		if (lang.length === 1) {
			this.onLanguageSelect('se');
		}

		return lang;
	};

	onLanguageSelect = (lang) => {
		console.log('SET LANGUAGE', lang);
		this.props.updateLanguage(lang);
		strings.setLanguage(lang);
		this.setState({
			languageSelected: lang,
		});
	};

	componentDidMount() {
		this.onLanguageSelect('se');
	}
	handleInputChange = (event) => {
		const target = event.target;
		const value =
			target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({
			candidateInfo: {
				...this.state.candidateInfo,
				[name]: value,
			},
		});
	};

	setEducation = (e) => {
		this.setState({
			education: e.target.value,
		});
	};

	handleReadyClick = (e) => {
		e.preventDefault();

		const {firstName, lastName, class: ageGroup} = this.state.candidateInfo;

		const updatedClass =
			this.state.education === 'other' ? 'other' : ageGroup;
		this.setState(
			{
				candidateInfo: {
					...this.state.candidateInfo,
					name: firstName + ' ' + lastName,
					class: updatedClass,
					testType: this.props.testKeyType,
				},
				ageGroup: updatedClass,
			},
			() => {
				this.props.onReadyClick(this.state.candidateInfo);
			}
		);
		return false;
	};

	handleCopy = () => {
		const textToCopy = 'https://followup.dysmate.se/';

		navigator.clipboard
			.writeText(textToCopy)
			.then(() => {
				this.setState({copied: true});
				setTimeout(() => this.setState({copied: false}), 1500);
			})
			.catch(() => {});
	};
	render() {
		const {roomKey, isClientReady} = this.props;
		const {languageSelected, copied} = this.state;
		if (!languageSelected) {
			return (
				<div>
					<h2>{strings.chooseLanguage}</h2>
					<div className="LanguageButton_wrapper">
						{this.getAvailableLanguages().map((lang, index) => (
							<button
								tabIndex={index + 1}
								className="LanguageButton"
								onClick={() => this.onLanguageSelect(lang)}
							>
								{strings['lang_' + lang]}
							</button>
						))}
					</div>
				</div>
			);
		}
		return (
			<div className="TestIntro">
				<div className="info-box">
					<p className="info-box__title">{strings.welcomeToTest}</p>
					<p className="info-box__hint">{''}</p>
					<ol>
						<div className="copy-wrapper">
							<li
								className="info-box__helpBoxList1"
								onClick={this.handleCopy}
								title="Click to copy"
							>
								{strings.helpBoxList1}
							</li>
							{copied && (
								<div className="copied-tooltip">
									Länk kopierad!
								</div>
							)}
						</div>

						<li>{strings.helpBoxList2}</li>
						<li>
							{strings.formatString(
								strings.helpBoxList3,
								<b>{roomKey}</b>
							)}
						</li>
						<li>{strings.helpBoxList4}</li>
						<li>{strings.helpBoxList5}</li>
					</ol>
				</div>
				<div>
					{!excludeForLang.includes(strings.getLanguage()) && (
						<h2>{strings.infoAboutCandidate}</h2>
					)}
					<form onSubmit={this.handleReadyClick} className="form">
						<Fragment>
							{!excludeForLang.includes(
								strings.getLanguage()
							) && <h2>{strings.generalInformation}</h2>}
							{!excludeForLang.includes(
								strings.getLanguage()
							) && (
								<p className="warning">
									{strings.formatString(
										strings.candidateReminder,
										<b>{strings.notaBene}</b>
									)}
								</p>
							)}

							<br />
							{!['child-followup'].includes(
								this.props.testKeyType
							) && (
								<label className="inline">
									{strings.firstName}{' '}
									<input
										type="text"
										name="firstName"
										placeholder={strings.firstName}
										onChange={this.handleInputChange}
										required
									/>
								</label>
							)}
							{!['child-followup'].includes(
								this.props.testKeyType
							) && (
								<label className="inline">
									{strings.lastName}{' '}
									<input
										type="text"
										name="lastName"
										placeholder={strings.lastName}
										onChange={this.handleInputChange}
										required
									/>
								</label>
							)}

							{!['child-followup'].includes(
								this.props.testKeyType
							) && (
								<label>
									{strings.birthDate}
									<input
										type="date"
										name="birthdate"
										onChange={this.handleInputChange}
										required
									/>
								</label>
							)}

							{!['child-followup'].includes(
								this.props.testKeyType
							) && (
								<label>
									{strings.gender}
									<select
										name="gender"
										onChange={this.handleInputChange}
										required
									>
										<option value="">
											{strings.pickOne}
										</option>
										<option value="m">{strings.boy}</option>
										<option value="f">
											{strings.girl}
										</option>
										<option value="u">
											{strings.unspecified}
										</option>
									</select>
								</label>
							)}
						</Fragment>
						<Fragment>
							{!['child-followup'].includes(
								this.props.testKeyType
							) && <h2>{strings.education}</h2>}
							{!['child-followup'].includes(
								this.props.testKeyType
							) && (
								<div>
									<label>
										{strings.municipality}
										<input
											onChange={this.handleInputChange}
											required
											type="text"
											name="municipality"
											id="municipality"
											placeholder={strings.municipality}
										/>
									</label>
									<label>
										{strings.county}
										<input
											onChange={this.handleInputChange}
											required
											type="text"
											name="county"
											id="county"
											placeholder={strings.county}
										/>
									</label>
								</div>
							)}
							{!['child-followup'].includes(
								this.props.testKeyType
							) && (
								<div>
									<label>
										{strings.school}
										<input
											onChange={this.handleInputChange}
											required
											type="text"
											name="school"
											id="school"
											placeholder={strings.school}
										/>
									</label>
								</div>
							)}

							<div onChange={this.setEducation}>
								{!['child-followup'].includes(
									this.props.testKeyType
								) && (
									<label className="checkbox-group-title">
										{strings.educationLevel}
									</label>
								)}

								{this.props.testKeyType ===
									'youth-followup' && (
									<span>
										<label>
											<input
												required
												type="radio"
												name="education"
												value="ungdomsskole"
											/>
											{strings.juniorHighSchool}
										</label>
										{/* <label>
											<input
												required
												type="radio"
												name="education"
												value="videregaendeskole"
											/>
											{strings.highSchool}
										</label>
										<label>
											<input
												required
												type="radio"
												name="education"
												value="universitet"
											/>
											{strings.university}
										</label>
										<label>
											<input
												required
												type="radio"
												name="education"
												value="other"
											/>
											{strings.other}
										</label> */}
									</span>
								)}
								{this.props.testKeyType ===
									'adult-followup' && (
									<span>
										<label>
											<input
												required
												type="radio"
												name="education"
												value="videregaendeskole"
											/>
											{strings.highSchool}
										</label>
										<label>
											<input
												required
												type="radio"
												name="education"
												value="universitet"
											/>
											{strings.university}
										</label>
										<label>
											<input
												required
												type="radio"
												name="education"
												value="other"
											/>
											{strings.other}
										</label>
									</span>
								)}
							</div>
							<br />

							{false &&
								(this.props.testKeyType === 'child' ||
									this.props.testKeyType ===
										'child-followup') && (
									<label>
										{strings.class}
										<select
											required
											name="class"
											onChange={this.handleInputChange}
										>
											<option value="">
												{strings.class}
											</option>
											{/* <option value="1">
											{strings.formatString(
												strings.classNum,
												1
											)}
										</option> */}
											<option value="1">
												{strings.formatString(
													strings.classNum,
													1
												)}
											</option>
											<option value="2">
												{strings.formatString(
													strings.classNum,
													2
												)}
											</option>
											<option value="3">
												{strings.formatString(
													strings.classNum,
													3
												)}
											</option>
											<option value="4">
												{strings.formatString(
													strings.classNum,
													4
												)}
											</option>
											<option value="5">
												{strings.formatString(
													strings.classNum,
													5
												)}
											</option>
											<option value="6">
												{strings.formatString(
													strings.classNum,
													6
												)}
											</option>
										</select>
									</label>
								)}
							{this.state.education === 'ungdomsskole' && (
								<label>
									{strings.class}
									<select
										required
										name="class"
										onChange={this.handleInputChange}
									>
										<option value="">
											{strings.pickClass}
										</option>
										<option value="7">
											{strings.formatString(
												strings.classNum,
												7
											)}
										</option>
										<option value="8">
											{strings.formatString(
												strings.classNum,
												8
											)}
										</option>
										<option value="9">
											{strings.formatString(
												strings.classNum,
												9
											)}
										</option>
									</select>
								</label>
							)}
							{this.state.education === 'videregaendeskole' && (
								<label>
									{strings.class}
									<select
										required
										name="class"
										onChange={this.handleInputChange}
									>
										<option value="">
											{strings.pickStudyType}
										</option>
										<option value="studiespesialisering">
											{strings.specialization}
										</option>
										<option value="yrkesfag">
											{strings.vocational}
										</option>
									</select>
								</label>
							)}
							{this.state.education === 'universitet' && (
								<label>
									{strings.class}
									<select
										required
										name="class"
										onChange={this.handleInputChange}
									>
										<option value="">
											{strings.pickLevel}
										</option>
										<option value="bachelor">
											{strings.bachelor}
										</option>
										<option value="master">
											{strings.master}
										</option>
										<option value="phd">
											{strings.phd}
										</option>
									</select>
								</label>
							)}
							{this.state.education === 'other' && (
								<label>
									{strings.specify}
									<input
										required
										type="text"
										name="educationOtherExplain"
										onChange={this.handleInputChange}
									/>
								</label>
							)}
						</Fragment>
						{!['child-followup'].includes(
							this.props.testKeyType
						) && <h2>{strings.other}</h2>}

						{!['child-followup'].includes(
							this.props.testKeyType
						) && (
							<label>
								{strings.bilinguagualHomeQuestion}
								<select
									name="languagesInHome"
									required
									onChange={this.handleInputChange}
								>
									<option value="">{strings.pick}</option>
									<option value="one">
										{strings.unilingual}
									</option>
									<option value="two">
										{strings.bilingual}
									</option>
									<option value="multiple">
										{strings.multilingual}
									</option>
								</select>
							</label>
						)}
						{!['child-followup'].includes(
							this.props.testKeyType
						) && (
							<label>
								<input
									type="checkbox"
									name="agreedToPrivacyPolicy"
									required
								/>{' '}
								{strings.iConsent}
								<br />
								{strings.consentText}{' '}
								<a
									style={{color: 'orange'}}
									target="_blank"
									rel="noopener noreferrer"
									href="https://www.dysmate.se/personvernerklaering/"
								>
									{strings.literatePrivacyPolicy}
								</a>
							</label>
						)}

						<AdminReadyButton
							remoteIsReady={isClientReady}
							// onClick={this.handleReadyClick}
						/>
					</form>
				</div>
			</div>
		);
	}
}

export default TestIntro;
